import { useRef, useState } from "react";
import emailjs from "@emailjs/browser";

/* EMAILJS Service to be created at emailjs.com */
const YOUR_PUBLIC_KEY   = "au9-cH0BA1w3W-uWK";
const YOUR_SERVICE_ID   =  "service_n05ia0t"; 
const YOUR_TEMPLATE_ID  = "template_ziwwtgi";

export default function ContactForm({isMobile}) {
  const formRef = useRef();
  const [status, setStatus] = useState("idle"); // idle | sending | success | error

  const handleSubmit = (e) => {
    e.preventDefault();
    setStatus("sending");

    emailjs
      .sendForm(YOUR_SERVICE_ID, YOUR_TEMPLATE_ID, formRef.current, YOUR_PUBLIC_KEY)
      .then(() => {
        setStatus("success");
        formRef.current.reset();
      })
      .catch(() => setStatus("error"));
  };

  const inputWidthClass = isMobile ? 'flex allwidth' : 'flex width70'

  return (
    <div className="flex screensize">
      <div>
        <h1 className="text-shadow-light">Contactez-moi</h1>
        <h5>Je reviens vers vous aussi vite que possible !</h5>
      </div>

      <form className="flex flexdot7 allspace" ref={formRef} onSubmit={handleSubmit}>
        <div className={`flex width80 height80 ${isMobile ? '' : 'row '}`}>
            <div className="flex flexdot5" style={{justifyContent: 'flex-start', height: '30vh'}}>
                <div className={inputWidthClass}>
                    <label>Votre nom*</label>
                    <input type="text" name="from_name" required className="allspace padded5 bold app-input" />
                </div>
                <br />
                <div className={inputWidthClass}>
                    <label>Votre numéro de téléphone*</label>
                    <input required type="tel" name="telephone" className="allspace padded app-input" />
                </div>
                <br />
               
                <div className={inputWidthClass}>
                    <label>Votre adresse email ?</label>
                    <input type="email" name="reply_to" className="allspace padded5 app-input" />
                </div>
            </div>
            <div className="flex flexdot5">
                <label>Vous souhaitez m'en dire plus ?</label>
                <textarea name="message" rows={5} className="allspace padded1 app-input height80" />
            </div>
        </div>
       

       

        <button type="submit" disabled={status === "sending"} className={`app-button xlarge ${isMobile ? 'marged1' : ''}`}>
          {status === "sending" ? "Envoi…" : "Envoyer"}
        </button>
      </form>

      {status === "success" && <p>✅ Message envoyé !</p>}
      {status === "error"   && <p>❌ Une erreur est survenue. Réessayez.</p>}
    </div>
  );
}